<template>
  <div class="box">
    <el-row>
      <el-col :span="2" style="height:10px"> </el-col>
      <el-col :span="20">
        <div class="xingxi">
          <div class="tiao"></div>
          <i>数据处理</i>
        </div>
        <!-- <router-link to="order" class="fanhui">&lt;返回</router-link> -->
        <el-form
          :model="editForm"
          label-position="top"
          style="margin-top: 20px;"
          ref="editForm"
          :rules="editRules"
        >
          <el-card>
            <el-row>
              <el-col :span="8" :push="2">
                <h4><i style="color:#FF0000">*</i> 项目信息</h4>
              </el-col>

              <el-col :span="8" :pull="2">
                <el-form-item label="项目名称" prop="projectName">
                  <el-input
                    class="shipei"
                    placeholder="请输入项目名称"
                    v-model="editForm.projectName"
                  ></el-input>
                </el-form-item>
                <el-form-item label="项目获取时间" prop="shijian">
                  <el-date-picker
                    v-model="editForm.shijian"
                    value-format="yyyy-MM-dd"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    class="shipei"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="8" :pull="2">
                <el-form-item label="项目预算" prop="projectBudget">
                  <el-input
                    class="shipei"
                    placeholder="请输入项目预算"
                    v-model="editForm.projectBudget"
                    ><template slot="prepend">￥</template
                    ><template slot="append">元</template></el-input
                  >
                </el-form-item>
                <el-form-item>
                  <p style="margin-top:0;margin-bottom:10px;color:#606266">
                    <i style="color:#F56C6C">*</i> 项目所在地
                  </p>
                  <v-distpicker
                    hide-area
                    @province="onChangeProvince"
                    @city="onChangeCity"
                  ></v-distpicker>
                </el-form-item>
              </el-col>
            </el-row>
          </el-card>
          <el-card style="margin-top: 20px;">
            <el-row>
              <el-col :span="8" :push="2">
                <h4><i style="color:#FF0000">*</i> 数据成果</h4>
              </el-col>
              <el-col :span="16" :pull="2">
                <el-form-item prop="checkList">
                  <el-checkbox-group v-model="editForm.checkList">
                    <el-checkbox
                      label="MESH(倾斜模型)"
                      name="MESH(倾斜模型)"
                    ></el-checkbox>
                    <el-checkbox
                      label="TDOM(直正摄影像)"
                      name="TDOM(直正摄影像)"
                    ></el-checkbox>
                    <el-checkbox
                      label="DSM(数字表面模型)"
                      name="DSM(数字表面模型)"
                    ></el-checkbox>
                    <el-checkbox
                      label="3DSHP(三维矢量数据)"
                      name="3DSHP(三维矢量数据)"
                    ></el-checkbox>
                    <el-checkbox
                      label="DEM(数字高程模型)"
                      name="DEM(数字高程模型)"
                      style="margin-top: 20px;"
                    ></el-checkbox>
                    <el-checkbox
                      label="DLG(数字线划图)"
                      name="DLG(数字线划图)"
                      style="margin-top: 20px;"
                    ></el-checkbox>
                    <el-checkbox
                      label="实景单体模型"
                      name="实景单体模型"
                      style="margin-top: 20px;"
                    ></el-checkbox>
                    <el-checkbox
                      label="语义模型"
                      name="语义模型"
                      style="margin-top: 20px;"
                    ></el-checkbox>
                    <el-checkbox
                      label="BIM"
                      name="BIM"
                      style="margin-top: 20px;"
                    ></el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </el-col>
            </el-row>
          </el-card>
          <el-card style="margin-top: 20px;">
            <el-row>
              <el-col :span="8" :push="2">
                <h4><i style="color:#FF0000">*</i> 成果要求</h4>
              </el-col>
              <el-col :span="16" :pull="2">
                <p>坐标系要求</p>
                <el-form-item prop="requirement">
                  <el-checkbox-group v-model="editForm.requirement">
                    <el-checkbox
                      label="CGCS 2000"
                      value="CGCS 2000"
                    ></el-checkbox>
                    <el-checkbox label="WGS 84" value="WGS 84"></el-checkbox>
                    <el-checkbox
                      label="地方坐坐标系"
                      value="地方坐坐标系"
                    ></el-checkbox>
                    <el-checkbox label="其他" value="其他">
                      <el-input
                        placeholder="其他"
                        style="width: 90px;"
                        size="mini"
                        v-model="zuobiaoxi"
                        @focus="choice1()"
                        @blur="blurzuobiao($event)"
                      ></el-input>
                    </el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
                <div>
                  <p style="font-size: 12px;">prj文件上传</p>
                  <a href="javascript:;" class="file">
                    <input
                      accept=".prj"
                      name="file"
                      type="file"
                      @change="update2"
                    />
                  </a>
                </div>
                <p>成果精度</p>
                <el-radio-group v-model="accuracy">
                  <el-radio label="1:500">1:500</el-radio>
                  <el-radio label="1:1000">1:1000</el-radio>
                  <el-radio label="1:2000">1:2000</el-radio>
                  <el-radio label="无">无</el-radio>
                  <el-radio label="其他">
                    1:
                    <el-input
                      placeholder="其他"
                      style="width: 90px;"
                      size="mini"
                      v-model="chengguojindu"
                      @focus="choice()"
                      @blur="blurjindu($event)"
                    ></el-input>
                  </el-radio>
                </el-radio-group>
              </el-col>
            </el-row>
          </el-card>
          <el-card v-if="this.MonomerModelDisplay" style="margin-top: 20px;">
            <el-row>
              <el-col :span="8" :push="2">
                <h4><i style="color:#FF0000">*</i>单体模型要求</h4>
              </el-col>
              <el-col :span="16" :pull="2">
                <el-form-item>
                  <el-input
                    type="textarea"
                    :rows="3"
                    v-model="editForm.MonomerModel"
                    placeholder="请输入单体模型要求"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-card>
          <el-card v-if="this.semanticModelDisplay" style="margin-top: 20px;">
            <el-row>
              <el-col :span="8" :push="2">
                <h4><i style="color:#FF0000">*</i>语义模型要求</h4>
              </el-col>
              <el-col :span="16" :pull="2">
                <el-form-item>
                  <el-input
                    type="textarea"
                    :rows="3"
                    v-model="editForm.semanticModel"
                    placeholder="请输入语义模型要求"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-card>
          <el-card v-if="this.bimDisplay" style="margin-top: 20px;">
            <el-row>
              <el-col :span="8" :push="2">
                <h4><i style="color:#FF0000">*</i>BIM要求</h4>
              </el-col>
              <el-col :span="16" :pull="2">
                <el-form-item>
                  <el-input
                    type="textarea"
                    :rows="3"
                    v-model="editForm.BIM"
                    placeholder="请输入BIM要求"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-card>
          <el-card style="margin-top: 20px;">
            <el-row>
              <el-col :span="8" :push="2">
                <h4><i style="color:#FF0000">*</i> 源数据信息</h4>
              </el-col>
              <el-col :span="16" :pull="2">
                <p><i style="color:#FF0000">*</i> 航飞分辨率</p>
                <el-radio-group v-model="resolving">
                  <el-radio label="3cm">3cm</el-radio>
                  <el-radio label="5cm">5cm</el-radio>
                  <el-radio label="7cm">7cm</el-radio>
                  <el-radio label="10cm">10cm</el-radio>
                  <el-radio label="其他">
                    <el-input
                      placeholder="其他"
                      style="width: 90px;"
                      size="mini"
                      v-model="fenbianlv"
                      @focus="choice2()"
                      @blur="blurfenbian($event)"
                    ></el-input
                    >cm
                  </el-radio>
                </el-radio-group>
                <p><i style="color:#FF0000">*</i> 照片数量</p>
                <el-form-item prop="zhaopianshuliang">
                  <el-input
                    placeholder="0"
                    style="width: 90px;"
                    size="mini"
                    v-model="editForm.zhaopianshuliang"
                  ></el-input>
                  <i style="font-size:12px">张</i>
                </el-form-item>
                <p><i style="color:#FF0000">*</i> 飞行器信息</p>

                <el-form-item prop="value">
                  <i style="font-size:12px; margin-right: 10px;">飞行器类型</i>
                  <el-select
                    v-model="editForm.value"
                    placeholder="请选择"
                    style="width: 90px; margin-right: 30px;"
                  >
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item prop="feixingqixinhao">
                  <i style="font-size:12px; margin-right: 10px;">飞行器型号</i>
                  <el-input
                    placeholder="请输入"
                    style="width: 90px;"
                    size="mini"
                    v-model="editForm.feixingqixinhao"
                  ></el-input>
                </el-form-item>
                <p><i style="color:#FF0000">*</i> 控制点有无</p>
                <el-radio-group v-model="whether">
                  <el-radio label="有">有</el-radio>
                  <el-radio label="无">无</el-radio>
                  <el-form-item
                    prop="kongzhidianshu"
                    v-if="this.whether == '有'"
                  >
                    <i style="font-size:12px;margin-right: 10px">控制点数量</i>
                    <el-input
                      placeholder="请输入"
                      style="width: 90px;"
                      size="mini"
                      v-model="editForm.kongzhidianshu"
                    ></el-input>
                  </el-form-item>
                </el-radio-group>
                <p><i style="color:#FF0000">*</i> 航摄仪信息</p>
                <div class="hangsheyi">
                  <el-form-item prop="hangsheyixinghao">
                    <i style="font-size:12px; margin-right: 10px;"
                      >航摄仪型号</i
                    >
                    <el-input
                      placeholder="请输入型号"
                      style="width: 90px;"
                      size="mini"
                      v-model="editForm.hangsheyixinghao"
                    ></el-input>
                  </el-form-item>
                </div>
                <div class="xiangfu" style="margin-top: 20px;">
                  <el-form-item prop="xiangfukuandu">
                    <i style="font-size:12px; margin-right: 10px;">相幅宽度</i>
                    <el-input
                      placeholder="请输入"
                      style="width: 90px;"
                      size="mini"
                      v-model="editForm.xiangfukuandu"
                    ></el-input
                    >像素
                  </el-form-item>
                  <el-form-item prop="xiangfugaodu">
                    <i style="font-size:12px; margin-right: 10px;">相幅高度</i>
                    <el-input
                      placeholder="请输入"
                      style="width: 90px;"
                      size="mini"
                      v-model="editForm.xiangfugaodu"
                    ></el-input
                    >像素
                  </el-form-item>
                </div>
                <div class="chuangan" style="margin-top: 20px;">
                  <el-form-item prop="chuanganqikuandu">
                    <i style="font-size:12px; margin-right: 10px;"
                      >传感器宽度</i
                    >
                    <el-input
                      placeholder="请输入"
                      style="width: 90px;"
                      size="mini"
                      v-model="editForm.chuanganqikuandu"
                    ></el-input
                    >mm
                  </el-form-item>
                </div>
                <div class="jintou" style="margin-top: 20px;">
                  <el-form-item prop="jintoujiaoju">
                    <i style="font-size:12px; margin-right: 10px;">镜头焦距</i>
                    <el-input
                      placeholder="请输入"
                      style="width: 90px;"
                      size="mini"
                      v-model="editForm.jintoujiaoju"
                    ></el-input
                    >mm
                  </el-form-item>
                </div>
                <div class="jintoushu" style="margin-top: 20px;">
                  <el-form-item prop="jintoushuliang">
                    <i style="font-size:12px; margin-right: 10px;">镜头数量</i>
                    <el-input
                      placeholder="请输入"
                      style="width: 90px;"
                      size="mini"
                      v-model="editForm.jintoushuliang"
                    ></el-input
                    >个
                  </el-form-item>
                </div>
                <div class="geshi" style="margin-top: 20px;">
                  <el-form-item prop="value1">
                    <i style="font-size:12px; margin-right: 10px;">影像格式</i>
                    <el-select
                      v-model="editForm.value1"
                      placeholder="请选择"
                      style="width: 90px; margin-right: 30px;"
                      size="mini"
                    >
                      <el-option
                        v-for="item in options1"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <p><i style="color:#FF0000">*</i> 布控需求</p>
                <el-radio-group v-model="demand">
                  <el-radio label="需求方自理">需求方自理</el-radio>
                  <el-radio label="由服务商布控并提供控制点"
                    >由服务商布控并提供控制点</el-radio
                  >
                </el-radio-group>
              </el-col>
            </el-row>
          </el-card>
          <el-card style="margin-top: 20px;">
            <el-row>
              <el-col :span="8" :push="2">
                <h4><i style="color:#FF0000">*</i> 测区范围</h4>
              </el-col>
              <el-col :span="16" :pull="2">
                <el-form-item prop="zuoyemianji">
                  <p>作业面积</p>
                  <el-input
                    placeholder="请输入"
                    style="width: 250px;"
                    v-model="editForm.zuoyemianji"
                  ></el-input
                  >km²
                </el-form-item>

                <el-radio v-model="radio" label="1"
                  >KML/SHP/CAD文件导入</el-radio
                >

                <el-radio style="margin-top: 40px;" v-model="radio" label="2"
                  >坐标输入</el-radio
                >
                <div style="margin-top: 10px;" v-if="this.radio == '1'">
                  <a href="javascript:;" class="file">
                    <input name="file" type="file" @change="update" />
                  </a>
                </div>

                <el-form
                  v-if="this.radio == '2'"
                  size="mini"
                  label-position="top"
                  :inline="true"
                  ref="zuobiaoform"
                  :model="zuobiaoform"
                  :rules="zuobiaorules"
                  style="margin-top: 10px;"
                >
                  <el-form-item
                    label="中心点经度"
                    prop="center.lng"
                    :rules="[
                      { required: true, message: '中心点经度不能为空' },
                      { type: 'number', message: '中心点经度必须为数字值' }
                    ]"
                  >
                    <el-input
                      v-model.number="zuobiaoform.center.lng"
                      placeholder="中心点经度"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    label="中心点纬度"
                    prop="center.lat"
                    :rules="[
                      { required: true, message: '中心点纬度不能为空' },
                      { type: 'number', message: '中心点纬度必须为数字值' }
                    ]"
                  >
                    <el-input
                      v-model.number="zuobiaoform.center.lat"
                      placeholder="中心点纬度"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="半径" prop="radius">
                    <el-input v-model="zuobiaoform.radius" placeholder="半径"
                      ><template slot="append">m</template></el-input
                    >
                  </el-form-item>
                  <el-form-item style="margin-top: 35px;">
                    <el-button
                      @click="tankuang()"
                      type="primary"
                      icon="el-icon-map-location"
                    ></el-button>
                  </el-form-item>
                </el-form>
              </el-col>
            </el-row>
          </el-card>
          <el-card style="margin-top: 20px;">
            <el-row>
              <el-col :span="8" :push="2">
                <h4>添加附件</h4>
              </el-col>
              <el-col :span="16" :pull="2">
                <div>
                  <a href="javascript:;" class="file">
                    <input name="file" type="file" @change="update1" />
                  </a>
                </div>
              </el-col>
            </el-row>
          </el-card>
          <el-card style="margin-top: 20px;">
            <el-row>
              <el-col :span="8" :push="2">
                <h4>备 注</h4>
              </el-col>
              <el-col :span="16" :pull="2">
                <el-input
                  type="textarea"
                  :rows="3"
                  placeholder="请输入内容"
                  v-model="peizhu"
                ></el-input>
              </el-col>
            </el-row>
          </el-card>
        </el-form>
        <div class="clearfix" style="margin-bottom:30px">
          <el-button
            @click="submission()"
            type="primary"
            style="margin-top: 10px;float: right;"
            >申请提交</el-button
          >
          <el-button
            @click="openDetails()"
            type="primary"
            style="float: right;margin-top: 10px;margin-right:20px"
            >订单预览</el-button
          >
        </div>
      </el-col>
      <el-col :span="2" style="height:10px"> </el-col>
    </el-row>

    <div
      class="mask"
      v-show="dialogVisible"
      @click="dialogVisible = false"
    ></div>
    <div class="pop" v-show="dialogVisible">
      <baidu-map
        v-show="dialogVisible"
        v-loading="loading"
        class="bm-view"
        :center="zuobiaoform.center"
        :zoom="zoom"
        @ready="handler"
      >
        <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
        <bm-geolocation
          anchor="BMAP_ANCHOR_BOTTOM_RIGHT"
          :showAddressBar="true"
          :autoLocation="true"
        ></bm-geolocation>
        <bm-city-list anchor="BMAP_ANCHOR_TOP_LEFT"></bm-city-list>
        <bm-circle
          :center="this.zuobiaoform.center"
          :radius="this.zuobiaoform.radius"
          fillColor="#0088ff"
          :fillOpacity="0.2"
          strokeColor="#0088ff"
          :strokeOpacity="0.2"
          :stroke-weight="2"
        ></bm-circle>
      </baidu-map>
    </div>
    <el-dialog title="订单预览" :visible.sync="DialogFormVisible">
      <!-- 项目信息 -->
      <el-card>
        <el-row>
          <el-col :span="8" :push="2">
            <h4>项目信息</h4>
          </el-col>
          <el-col :span="8" :pull="2">
            <div class="xianshi left">
              <p>
                <b>项目名称:</b>
                <i>{{ editForm.projectName }}</i>
              </p>
              <p>
                <b>项目获取时间：</b>
                <i>{{ editForm.shijian.toString() }}</i>
              </p>
            </div>
          </el-col>
          <el-col :span="8" :pull="2">
            <div class="xianshi right">
              <p>
                <b>项目预算:</b>
                <i>{{ editForm.projectBudget }}</i>
              </p>
              <p>
                <b>项目所在地:</b>
                <i>{{ chengshi + shiqu }}</i>
              </p>
            </div>
          </el-col>
        </el-row>
      </el-card>
      <!-- 数据处理采集手段 -->
      <el-card style="margin-top: 10px;">
        <el-row>
          <el-col :span="8" :push="2">
            <h4>采集手段</h4>
          </el-col>
          <el-col :span="16" :pull="2">
            <div class="xianshi left">
              <p>
                <b>{{ editForm.checkList.toString() }}</b>
              </p>
            </div>
            <!-- <div class="xianshi right">
              <p>
                <b>DSM（数字表面模型）</b>
              </p>
            </div> -->
          </el-col>
        </el-row>
      </el-card>

      <!-- 成果要求 -->
      <el-card style="margin-top: 10px;">
        <el-row>
          <el-col :span="8" :push="2">
            <h4>成果要求</h4>
          </el-col>
          <el-col :span="8" :pull="2">
            <div class="xianshi left">
              <p>
                <b>坐标系要求：</b>
                <i>{{ editForm.requirement.toString() }}</i>
              </p>
            </div>
          </el-col>
          <el-col :span="8" :pull="2">
            <div class="xianshi right">
              <p>
                <b>成果精度：</b>
                <i>{{
                  accuracy == "其他" ? "1:" + chengguojindu : accuracy
                }}</i>
              </p>
            </div>
          </el-col>
        </el-row>
      </el-card>
      <el-card v-if="this.MonomerModelDisplay" style="margin-top: 10px;">
        <el-row>
          <el-col :span="8" :push="2">
            <h4>单体模型要求</h4>
          </el-col>
          <el-col :span="16" :pull="2">
            <div class="xianshi left">
              <p>
                <b>{{ editForm.MonomerModel }}</b>
              </p>
            </div>
          </el-col>
        </el-row>
      </el-card>
      <el-card v-if="this.semanticModelDisplay" style="margin-top: 10px;">
        <el-row>
          <el-col :span="8" :push="2">
            <h4>语义模型要求</h4>
          </el-col>
          <el-col :span="16" :pull="2">
            <div class="xianshi left">
              <p>
                <b>{{ editForm.semanticModel }}</b>
              </p>
            </div>
          </el-col>
        </el-row>
      </el-card>
      <el-card v-if="this.bimDisplay" style="margin-top: 10px;">
        <el-row>
          <el-col :span="8" :push="2">
            <h4>BIM要求</h4>
          </el-col>
          <el-col :span="16" :pull="2">
            <div class="xianshi left">
              <p>
                <b>{{ editForm.BIM }}</b>
              </p>
            </div>
          </el-col>
        </el-row>
      </el-card>
      <!-- 源数据信息 -->
      <el-card style="margin-top: 10px;">
        <el-row>
          <el-col :span="8" :push="2">
            <h4>源数据信息</h4>
          </el-col>
          <el-col :span="8" :pull="2" class="rightbox">
            <div class="xianshi left">
              <p>
                <b>航飞分辨率：</b>
                <i>{{ resolving == "其他" ? fenbianlv : resolving }}</i>
              </p>
              <p>
                <b>飞行器类型：</b>
                <i>{{ editForm.value }}</i>
              </p>
              <p>
                <b>控制点：</b>
                <i>{{ editForm.kongzhidianshu }}</i>
              </p>
              <p>
                <b>航摄仪型号：</b>
                <i>{{ editForm.hangsheyixinghao }}</i>
              </p>
              <p>
                <b>传感器宽度：</b>
                <i>{{ editForm.chuanganqikuandu }}mm</i>
              </p>
              <p>
                <b>镜头数量：</b>
                <i>{{ editForm.jintoushuliang }}</i>
              </p>
              <p>
                <b>布控需求：</b>
                <i>{{ demand }}</i>
              </p>
            </div>
          </el-col>
          <el-col :span="8" :pull="2" class="rightbox">
            <div class="xianshi right">
              <p>
                <b>照片数量：</b>
                <i>{{ editForm.zhaopianshuliang }}</i>
              </p>
              <p>
                <b>飞行器型号：</b>
                <i>{{ editForm.feixingqixinhao }}</i>
              </p>
              <!-- <p>
                <b>控制点数量：</b>
                <i>{{ testData.data.data.kongzhidian.shuliang }}</i>
              </p> -->
              <!-- <div style="height:55px"></div> -->
              <p>
                <b>相幅宽度：</b>
                <i>{{ editForm.xiangfukuandu }}像素</i>
              </p>
              <p>
                <b>相幅高度：</b>
                <i>{{ editForm.xiangfugaodu }}像素</i>
              </p>
              <p>
                <b>镜头焦距：</b>
                <i>{{ editForm.jintoujiaoju }}mm</i>
              </p>
              <p>
                <b>影像格式：</b>
                <i>{{ editForm.value1 }}</i>
              </p>
            </div>
          </el-col>
        </el-row>
      </el-card>
      <!-- 测区范围 -->
      <el-card style="margin-top: 10px;">
        <el-row>
          <el-col :span="8" :push="2">
            <h4>测区范围</h4>
          </el-col>
          <el-col :span="8" :pull="2">
            <div class="xianshi left">
              <p>
                <b>作业区域范围</b>
              </p>
              <p v-if="this.radio == '1'">
                <i>{{ fanaweiwenjian }}</i>
              </p>
              <p v-if="this.radio == '2'">
                <b>中心点经度: </b>
                <i>{{ zuobiaoform.center.lng }}</i>
              </p>
              <p v-if="this.radio == '2'">
                <b>中心点纬度: </b>
                <i>{{ zuobiaoform.center.lat }}</i>
              </p>
              <p v-if="this.radio == '2'">
                <b>半径: </b>
                <i>{{ zuobiaoform.radius }}</i>
              </p>
            </div>
          </el-col>
          <el-col :span="8" :pull="2">
            <div class="xianshi right">
              <p>
                <b>作业区域面积: </b>
                <i>{{ editForm.zuoyemianji }}平方公里</i>
              </p>
            </div>
          </el-col>
        </el-row>
      </el-card>
      <!-- 附件信息 -->
      <el-card style="margin-top: 10px;">
        <el-row>
          <el-col :span="8" :push="2">
            <h4>附件信息</h4>
          </el-col>
          <el-col :span="16" :pull="2">
            <p></p>
            <i>{{ FuJianwenjian }}</i>
          </el-col>
        </el-row>
      </el-card>
      <!-- 备注 -->
      <el-card style="margin-top: 10px;">
        <el-row>
          <el-col :span="8" :push="2">
            <h4>备 注</h4>
          </el-col>
          <el-col :span="16" :pull="2">
            <div class="left xianshi">
              <i>{{ peizhu }}</i>
            </div>
          </el-col>
        </el-row>
      </el-card>
      <div style="height:30px">
        <el-button
          @click="submission()"
          type="primary"
          style="margin-top: 10px;float: right;"
          >申请提交</el-button
        >
        <el-button
          @click="closeDetails()"
          type="primary"
          style="margin-top: 10px;float: right;margin-right:20px"
          >编辑</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import VDistpicker from "v-distpicker";
// import moment from "moment";
export default {
  name: "dbmap",
  components: { VDistpicker },
  data() {
    var validate = (rule, value, callback) => {
      let boolean = /^(0|[1-9][0-9]*)(\.\d+)?$/;
      if (!boolean.test(value)) {
        callback(new Error("只可以输入正数"));
      } else {
        callback();
      }
    };
    var validate1 = (rule, value, callback) => {
      let boolean = /^[1-9][0-9]*$/;
      if (!boolean.test(value)) {
        callback(new Error("请输入正整数"));
      } else {
        callback();
      }
    };
    return {
      loading: true,
      zuobiaoform: {
        center: {
          lng: "",
          lat: ""
        },

        radius: ""
      },
      zuobiaorules: {
        radius: [
          { required: true, message: "请输入", trigger: "blur" },
          { validator: validate, trigger: "blur" }
        ]
        // lat: [{ type: "number", message: "必须为数字值" }],
        // lng: [{ type: "number", message: "必须为数字值" }]
      },
      radio: "1",
      dituVisible: false,
      chengshi: "",
      shiqu: "",

      DialogFormVisible: false,
      peizhu: "",
      fenbianlv: "",
      chengguojindu: "",
      zuobiaoxi: "",

      editForm: {
        projectName: "",
        projectBudget: "",
        shijian: [],
        checkList: [],
        requirement: [],
        zhaopianshuliang: "",
        value: "",
        feixingqixinhao: "",
        kongzhidianshu: "",
        hangsheyixinghao: "",
        xiangfukuandu: "",
        xiangfugaodu: "",
        chuanganqikuandu: "",
        jintoujiaoju: "",
        jintoushuliang: "",
        value1: "",
        zuoyemianji: "",
        MonomerModel: "",
        semanticModel: "",
        BIM: ""
      },
      editRules: {
        projectName: [{ required: true, message: "请输入", trigger: "blur" }],
        shijian: [{ required: true, message: "请选择日期", trigger: "change" }],
        projectBudget: [
          { required: true, message: "请输入", trigger: "blur" },
          { validator: validate, trigger: "blur" }
        ],
        checkList: [
          {
            required: true,
            message: "请至少选择一个数据成果",
            trigger: "change"
          }
        ],
        requirement: [
          {
            required: true,
            message: "请至少选择一个坐标系要求",
            trigger: "change"
          }
        ],
        zhaopianshuliang: [
          { required: true, message: "请输入", trigger: "blur" },
          { validator: validate1, trigger: "blur" }
        ],
        value: [
          { required: true, message: "请选择活动区域", trigger: "change" }
        ],
        // feixingqixinhao: [
        //   { required: true, message: "请输入", trigger: "blur" }
        // ],
        kongzhidianshu: [
          { required: true, message: "请输入", trigger: "blur" },
          { validator: validate1, trigger: "blur" }
        ],
        hangsheyixinghao: [
          { required: true, message: "请输入", trigger: "blur" }
        ],
        xiangfukuandu: [
          { required: true, message: "请输入", trigger: "blur" },
          { validator: validate1, trigger: "blur" }
        ],
        xiangfugaodu: [
          { required: true, message: "请输入", trigger: "blur" },
          { validator: validate1, trigger: "blur" }
        ],
        chuanganqikuandu: [
          { required: true, message: "请输入", trigger: "blur" },
          { validator: validate, trigger: "blur" }
        ],
        jintoujiaoju: [
          { required: true, message: "请输入", trigger: "blur" },
          { validator: validate, trigger: "blur" }
        ],
        value1: [{ required: true, message: "请选择", trigger: "change" }],
        zuoyemianji: [
          { required: true, message: "请输入", trigger: "blur" },
          { validator: validate, trigger: "blur" }
        ],
        jintoushuliang: [{ required: true, message: "请输入", trigger: "blur" }]
      },

      //成果精度多选
      accuracy: "1:500",
      options: [
        {
          value: "固定翼（有人机）",
          label: "固定翼（有人机）"
        },
        {
          value: "直升机（有人机）",
          label: "直升机（有人机）"
        },
        {
          value: "固定翼（无人机）",
          label: "固定翼（无人机）"
        },
        {
          value: "旋翼机（无人机）",
          label: "旋翼机（无人机）"
        },
        {
          value: "直升机（无人机）",
          label: "直升机（无人机）"
        },
        {
          value: "复合翼（无人机）",
          label: "复合翼（无人机）"
        }
      ],

      options1: [
        {
          value: "JPG",
          label: "JPG"
        },
        {
          value: "TIFF",
          label: "TIFF"
        },
        {
          value: "3DML",
          label: "3DML"
        },
        {
          value: "OSGB",
          label: "OSGB"
        },
        {
          value: "LAS",
          label: "LAS"
        },
        {
          value: "SHP",
          label: "SHP"
        },
        {
          value: "DXF",
          label: "DXF"
        }
      ],

      //空域服务多选
      resolving: "3cm",
      //控制点有无多选
      whether: "有",
      //布控需求多选
      demand: "需求方自理",
      fanaweiwenjian: "",
      FuJianwenjian: "",
      bichuanwenjian: false,
      upform: {
        function: "t_order",
        jsonData: {
          type: "2",
          name: "",
          // createTime: "",
          data: {},
          userId: ""
        }
      },
      center: { lng: 0, lat: 0 },
      zoom: 3,
      locaPoint: null,
      application: {
        host: "parallelword@terra-it.cn",
        title: "平行世界",
        content: ""
      },
      dialogVisible: false,
      prjWenjian: "",
      bimDisplay: false,
      MonomerModelDisplay: false,
      semanticModelDisplay: false
    };
  },
  watch: {
    "editForm.checkList": {
      handler(newVal) {
        newVal.forEach(element => {
          if (element == "实景单体模型") {
            this.MonomerModelDisplay = true;
          }
          if (element == "语义模型") {
            this.semanticModelDisplay = true;
          }
          if (element == "BIM") {
            this.bimDisplay = true;
          }
        });
        if (newVal.indexOf("实景单体模型") == -1) {
          this.MonomerModelDisplay = false;
        }
        if (newVal.indexOf("语义模型") == -1) {
          this.semanticModelDisplay = false;
        }
        if (newVal.indexOf("BIM") == -1) {
          this.bimDisplay = false;
        }
      },
      deep: true
    }
  },
  created() {
    this.sessionData();
  },
  mounted() {},
  methods: {
    tankuang() {
      this.dialogVisible = true;
    },
    async submit() {
      var content = `平行世界有新增订单申请待处理`;
      this.application.content = content;
      const { data: dt } = await this.$http.post(
        "general/sendMail",
        this.application
      );
      if (dt.status !== 200) {
        return this.$message.error(dt.msg);
      }
    },
    // updateCirclePath(e) {
    //   console.log(e.target.getRadius());
    //   console.log(e.target.getCenter());
    //   console.log(e.target);
    //   console.log(e.type);
    //   // this.zuobiaoform.center = e.target.getCenter();
    //   // let bajin = e.target.getRadius();
    //   // this.zuobiaoform.radius = bajin.toFixed(2);

    //   // this.zuobiaoform.radius = e.target.getRadius();
    // },

    handler({ BMap, map }) {
      var _that = this;
      var geolocation = new BMap.Geolocation();
      geolocation.getCurrentPosition(
        r => {
          this.zuobiaoform.center = {
            lng: r.point.lng,
            lat: r.point.lat
          };
          this.locaPoint = r.point;
          this.loading = false;
          // console.log(r);

          // _this.center.lng = r.point.lng;
          // _this.center.lat = r.point.lat;
          // alert("您的位置：" + r.point.lng + "," + r.point.lat);
        },
        {
          // 指示浏览器获取高精度的位置，默认为false
          enableHighAcuracy: true
        }
      );

      this.zoom = 15;
      var points = [];

      map.addEventListener("click", e => {
        map.clearOverlays();
        var point = new BMap.Point(e.point.lng, e.point.lat);
        points.push(new BMap.Point(e.point.lng, e.point.lat));
        if (points.length == 1) {
          var marker = new BMap.Marker(point);
          //给覆盖物添加右键菜单
          var removeMarker = function() {
            map.clearOverlays();
            points.length = 0;
          };
          //创建右键菜单
          var markerMenu = new BMap.ContextMenu();
          markerMenu.addItem(
            new BMap.MenuItem("删除", removeMarker.bind(marker))
          );
          map.addOverlay(marker);
          marker.addContextMenu(markerMenu);
        } else if (points.length == 2) {
          var radLat1 = (points[0].lat * Math.PI) / 180.0;
          var radLat2 = (points[1].lat * Math.PI) / 180.0;
          var a = radLat1 - radLat2;
          var b =
            (points[0].lng * Math.PI) / 180.0 -
            (points[1].lng * Math.PI) / 180.0;
          var s =
            2 *
            Math.asin(
              Math.sqrt(
                Math.pow(Math.sin(a / 2), 2) +
                  Math.cos(radLat1) *
                    Math.cos(radLat2) *
                    Math.pow(Math.sin(b / 2), 2)
              )
            );
          s = s * 6378137.0; // 取WGS84标准参考椭球中的地球长半径(单位:m)
          s = Math.round(s * 10000) / 10000;
          var circle = new BMap.Circle(points[0], s, {
            strokeColor: "#0088ff",
            fillColor: "#0088ff",
            strokeWeight: 2,
            strokeOpacity: 0.2,
            fillOpacity: 0.2
          }); //创建圆
          map.addOverlay(circle);
          // console.log(Object.prototype.toString.call(circle.getRadius()));
          _that.zuobiaoform.radius = circle.xa;
          _that.zuobiaoform.center = circle.point;
          // _that.zuobiaoform.radius = circle.getCenter();
          // _that.zuobiaoform.center = circle.getRadius();
          points.length = 0;
        }
      });
    },
    //获取选择的省市
    onChangeProvince(a) {
      this.chengshi = a.value;
    },
    onChangeCity(a) {
      this.shiqu = a.value;
    },

    closeDetails() {
      this.DialogFormVisible = false;
    },
    openDetails() {
      if (this.radio == "2") {
        if (
          this.zuobiaoform.radius == "" ||
          this.zuobiaoform.center.lat == "" ||
          this.zuobiaoform.center.lng == ""
        ) {
          return this.$message.error("请填写坐标输入内容");
        }
      }
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.DialogFormVisible = true;
        }
      });
    },
    blurfenbian(e) {
      let bool = new RegExp("^[1-9][0-9]*").test(e.target.value);
      if (!bool) {
        return this.$message.warning("请输入其他分辨率，只可输入数字");
      }
    },
    blurjindu(e) {
      let bool = new RegExp("^[1-9][0-9]*").test(e.target.value);
      if (!bool) {
        return this.$message.warning("请输入其他精度，只可输入数字");
      }
    },
    blurzuobiao(e) {
      if (e.target.value == "") {
        return this.$message.warning("请输入其他坐标");
      }
    },
    async sessionData() {
      let config = {
        headers: { "Content-Type": "application/x-www-form-urlencoded" }
      };
      const { data: dt } = await this.$http.post(
        "user/getUserInfo",
        "",
        config
      );
      this.testData = dt.data;
      this.upform.jsonData.userId = this.testData.id;
      // console.log(this.upform.jsonData.userId)
    },
    submission() {
      if (this.chengshi == "" && this.shiqu == "") {
        return this.$message.error("请填写项目所在地");
      }
      if (this.radio == "1") {
        if (this.bichuanwenjian == false) {
          return this.$message.error("请上传KML/SHP/CAD文件");
        }
      }
      if (this.radio == "2") {
        if (
          this.zuobiaoform.radius == "" ||
          this.zuobiaoform.center.lat == "" ||
          this.zuobiaoform.center.lng == ""
        ) {
          return this.$message.error("请填写坐标输入内容");
        }
      }

      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.$confirm("确认要提交订单么?", "提交", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          })
            .then(async () => {
              // var tm = moment(new Date().getTime()).format("YYYY-MM-DD HH:mm:ss");
              let feixinqixingxi = {
                feixingqileixin: this.editForm.value,
                feixingqixinhao: this.editForm.feixingqixinhao
              };
              if (this.whether == "有") {
                this.upform.jsonData.data.kongzhidian = this.editForm.kongzhidianshu;
              } else if (this.whether == "无") {
                this.upform.jsonData.data.kongzhidian = this.whether;
              }

              this.upform.jsonData.name = this.editForm.projectName;
              // this.upform.jsonData.createTime = tm;
              this.upform.jsonData.data.suozaidi = this.chengshi + this.shiqu;
              this.upform.jsonData.data.shijianDuan = this.editForm.shijian.toString();
              this.upform.jsonData.data.projectBudget = this.editForm.projectBudget;
              this.upform.jsonData.data.caijishouduan = this.editForm.checkList.toString();

              this.editForm.requirement.forEach((e, a) => {
                if (e == "其他") {
                  this.editForm.requirement.splice(a, 1, this.zuobiaoxi);
                }
              });
              this.upform.jsonData.data.zuobiaoxi = this.editForm.requirement.toString();
              this.upform.jsonData.data.prjWenjian = this.prjWenjian;
              this.upform.jsonData.data.chengguojindu = this.accuracy;
              this.upform.jsonData.data.hangfeifenbianlv = this.resolving;
              if (this.accuracy == "其他") {
                this.upform.jsonData.data.chengguojindu =
                  "1：" + this.chengguojindu;
              }

              if (this.resolving == "其他") {
                this.upform.jsonData.data.hangfeifenbianlv = this.fenbianlv;
              }

              this.upform.jsonData.data.zhaopianshuliang = this.editForm.zhaopianshuliang;
              this.upform.jsonData.data.feixinqixingxi = JSON.stringify(
                feixinqixingxi
              );
              if (this.MonomerModelDisplay) {
                this.upform.jsonData.data.MonomerModel = this.editForm.MonomerModel;
              }
              if (this.semanticModelDisplay) {
                this.upform.jsonData.data.semanticModel = this.editForm.semanticModel;
              }
              if (this.bimDisplay) {
                this.upform.jsonData.data.BIM = this.editForm.BIM;
              }
              this.upform.jsonData.data.hangsheyixinghao = this.editForm.hangsheyixinghao;
              this.upform.jsonData.data.xiangfukuandu = this.editForm.xiangfukuandu;
              this.upform.jsonData.data.xiangfugaodu = this.editForm.xiangfugaodu;
              this.upform.jsonData.data.chuanganqikuandu = this.editForm.chuanganqikuandu;
              this.upform.jsonData.data.jintoujiaoju = this.editForm.jintoujiaoju;
              this.upform.jsonData.data.jintoushuliang = this.editForm.jintoushuliang;
              this.upform.jsonData.data.zuoyemianji = this.editForm.zuoyemianji;
              this.upform.jsonData.data.BeiZhu = this.peizhu;
              this.upform.jsonData.data.yingxianggeshi = this.editForm.value1;
              this.upform.jsonData.data.bukongxuqiu = this.demand;
              this.upform.jsonData.data.FuJianWenJian = this.FuJianwenjian;
              if (this.radio == "1") {
                this.upform.jsonData.data.fanaweiwenjian = this.fanaweiwenjian;
              }
              if (this.radio == "2") {
                this.upform.jsonData.data.lat = this.zuobiaoform.center.lat;
                this.upform.jsonData.data.lng = this.zuobiaoform.center.lng;
                this.upform.jsonData.data.zuobiaobanjin = this.zuobiaoform.radius;
              }
              // console.log(JSON.stringify(this.upform.jsonData));
              this.upform.jsonData.data = JSON.stringify(
                this.upform.jsonData.data
              );
              this.upform.jsonData = JSON.stringify(this.upform.jsonData);
              const { data: dt } = await this.$http.post(
                "order/insert",
                this.upform
              );
              // console.log(dt);
              if (dt.status !== 200) {
                return this.$message.error(dt.msg);
              }
              this.submit();
              this.$router.push("/users");
            })
            .catch(() => {});
        }
      });
    },
    update2(e) {
      // var self = this;
      let file = e.target.files[0];
      /* eslint-disable no-undef */
      let param = new FormData(); // 创建form对象
      param.append("file", file); // 通过append向form对象添加数据
      // param.append("chunk", "0"); // 添加form表单中其他数据
      // console.log(param.get("file")); // FormData私有类对象，访问不到，可以通过get判断值是否传进去
      let config = {
        headers: { "Content-Type": "multipart/form-data" }
      };
      // 添加请求头
      this.$http.post("general/upload", param, config).then(response => {
        // console.log(response.data);
        if (response.data.status !== 200) {
          return this.$message.error(response.data.msg);
        }
        this.prjWenjian = response.data.data.result;
      });
    },
    update1(e) {
      // var self = this;
      let file = e.target.files[0];
      /* eslint-disable no-undef */
      let param = new FormData(); // 创建form对象
      param.append("file", file); // 通过append向form对象添加数据
      // param.append("chunk", "0"); // 添加form表单中其他数据
      // console.log(param.get("file")); // FormData私有类对象，访问不到，可以通过get判断值是否传进去
      let config = {
        headers: { "Content-Type": "multipart/form-data" }
      };
      // 添加请求头
      this.$http.post("general/upload", param, config).then(response => {
        // console.log(response.data);
        if (response.data.status !== 200) {
          return this.$message.error(response.data.msg);
        }
        this.FuJianwenjian = response.data.data.result;
      });
    },
    update(e) {
      // var self = this;
      let file = e.target.files[0];
      /* eslint-disable no-undef */
      let param = new FormData(); // 创建form对象
      param.append("file", file); // 通过append向form对象添加数据
      // param.append("chunk", "0"); // 添加form表单中其他数据
      // console.log(param.get("file")); // FormData私有类对象，访问不到，可以通过get判断值是否传进去
      let config = {
        headers: { "Content-Type": "multipart/form-data" }
      };
      // 添加请求头
      this.$http.post("general/upload", param, config).then(response => {
        // console.log(response.data);
        if (response.data.status !== 200) {
          return this.$message.error(response.data.msg);
        }
        this.fanaweiwenjian = response.data.data.result;
      });
      this.bichuanwenjian = true;
    },

    choice2() {
      this.resolving = "其他";
    },
    choice1() {
      this.editForm.requirement.push("其他");
    },
    choice() {
      this.accuracy = "其他";
    }
  }
};
</script>

<style lang="less" scoped>
.box {
  background: #f2f2f2;
}
.mask {
  background-color: #000;
  opacity: 0.5;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}
.pop {
  padding-top: 20px;
  overflow: hidden;
  box-sizing: border-box;
  background-color: #fff;

  position: fixed;
  top: 100px;
  left: 550px;
  width: calc(100% - 800px);
  height: 500px;
  z-index: 2;
}
.bm-view {
  width: 100%;
  height: 500px;
}
.shipei {
  width: 250px;
}
@media (max-width: 1920px) {
  .shipei {
    width: 320px;
  }
}
@media (max-width: 1500px) {
  .shipei {
    width: 250px;
  }
}
.el-card {
  overflow: auto;
}
.box {
  position: relative;
}
.fanhui {
  position: absolute;
  top: 90px;
  right: 8%;
}
i {
  font-style: normal;
}
.xingxi {
  width: 90px;
  margin-top: 90px;
  // position: absolute;
  // left: 70px;
  // top: 60px;
  .tiao {
    width: 4px;
    height: 15px;
    background: rgba(0, 134, 253, 1);
    display: inline-block;
    margin-right: 10px;
  }
  i {
    // width: 65px;
    font-weight: bold;
    font-size: 16px;
  }
}
.diaiog {
  overflow: hidden;
  .left {
    float: left;
  }
  .right {
    float: right;
    margin-right: 200px;
    width: 250px;
  }

  .xingxidanhao {
    margin-top: 30px;
    height: 180px;
    background-color: #0086fd;
    p {
      color: #fff;
    }
  }
  li {
    list-style-type: none;
    float: left;
    margin-right: 170px;
  }
  li:last-child {
    margin-right: 0;
  }
  .ding {
    height: 20px;
  }
  .fanhui {
    float: right;
  }
  i {
    font-style: normal;
  }
}
</style>
